import { render, staticRenderFns } from "./OrderFlagData.vue?vue&type=template&id=14ce2448"
import script from "./OrderFlagData.vue?vue&type=script&lang=js"
export * from "./OrderFlagData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports